<script>
import { mapActions } from 'vuex';

export default {
  data() {
    return {
      list: [
        {
          text: 'Легковые автомобили',
          url: '/public/images/pages/vikup/image1.png',
        },
        {
          text: 'Битые автомобили',
          url: '/public/images/pages/vikup/image2.png',
        },
        {
          text: 'Кредитные автомобили',
          url: '/public/images/pages/vikup/image3.png',
        },
        {
          text: 'Коммерческие автомобили',
          url: '/public/images/pages/vikup/image4.png',
        },
        {
          text: 'Автомобили не на ходу',
          url: '/public/images/pages/vikup/image5.png',
        },
        {
          text: 'Автомобили в залоге/лизинге',
          url: '/public/images/pages/vikup/image6.png',
        },
      ],
    };
  },
  methods: {
    ...mapActions({
      togglePopup: 'Popups/togglePopup',
      addTitlePopup: 'Popups/addTitlePopup',
    }),

    openPopup() {
      this.togglePopup('order-call-with-message');
      this.addTitlePopup('<span>Подать</span> заявку на выкуп');
    },
  },
};
</script>

<template>
  <div class="section section_gray section_indents">
    <div class="container">
      <h2 class="title-h2 !mb-1">Какие автомобили мы выкупаем?</h2>
      <p class="mb-3.5 text-green">Мы выкупаем все автомобили, любого возраста и пробега.</p>

      <div class="flex flex-col lg:flex-row">
        <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 xl:grid-cols-3 gap-x-4 mb-4 -mt-6">
          <div
            v-for="(item, index) in list"
            :key="index"
            class="pt-12"
            @click="openPopup"
          >
            <div class="flex flex-col h-full px-4 pt-4 bg-white rounded-big-brand hover:shadow-brand cursor-pointer transition ease-in-out duration-200">
              <div class="flex items-center justify-between -mt-12">
                <img
                  :src="item.url"
                  alt=""
                  class="w-full h-auto"
                >
              </div>
              <div class="flex pb-4 mt-auto overflow-hidden">
                <div class="pr-4">
                  <div class="relative hidden sm:block transform -rotate-90 text-4xl font-medium text-gray-300">
                    {{ '0' + (index + 1) }}
                    <span class="absolute w-28 h-0 top-1/2 left-0 border transform -translate-x-full border-gray-300"></span>
                  </div>
                </div>

                <div>
                  <p class="text-gray-600">{{ item.text }}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="relative hidden lg:block w-full lg:w-1/3 xl:w-1/4">
          <div class="static lg:absolute top-0 left-0 w-full lg:w-[calc(100%+(100vw-890px)/2)] xl:w-[calc(100%+(100vw-1140px)/2)] 2xl:w-[calc(100%+(100vw-1220px)/2)] h-full flex items-center justify-center">
            <img
              class="w-full sm:w-10/12 lg:w-full max-w-[700px] h-auto"
              src="/public/images/pages/vikup/image-25.png"
              alt=""
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

